import React from 'react';
import BaseButton from 'react-bootstrap/Button';
import cls from 'classnames';
import styles from './button.module.css';
import PropTypes from 'prop-types';

const Button = ({ loading = false, variant, disabled, className, children, ...rest }) => {
    return (
        <BaseButton
            {...rest}
            variant={variant}
            disabled={disabled || loading}
            className={cls(styles.button, className, {
                [styles.disabled]: disabled,
                [styles.primaryDisabled]: disabled && variant === 'primary',
                [styles.outlinePrimaryDisabled]: disabled && variant === 'outline-primary',
            })}
        >
            {children}
            {loading && <span className={styles.spinner} />}
        </BaseButton>
    );
};

Button.propTypes = {
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    loading: PropTypes.bool,
};

export default Button;
